//The data of the message that will be sent for every update
export default class UpdateMessage {

  private type : string = 'update';
  private id   : string;
  private x2   : number;
  private y2   : number;

  constructor(id : string, x : number, y : number){
    this.id = id;
    this.x2 = x;
    this.y2 = y;
  }
}